import React from 'react';

import Layout from '../components/Layout/Layout';
import { buildPrimaryPostPage } from '../util/buildPrimaryPostPage';

const RootLayout = (props) => {
    return (
        <Layout head={props.head} menu={props.menu} preview={props.preview}>
            {props.children}
        </Layout>
    );
};

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryPostPage({
        site: 'ROOT',
        LayoutComponent: RootLayout,
        pathFormatter: (slug) => slug.join('/'),
        postType: 'PAGE',
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
